import { memo } from 'react'
import { useNavigate } from '@tanstack/react-router'

import { useStore } from '@/lib/store/useStore'

import View, { type StatusColor } from './DebugInfoTooltip.view'

export interface ControllerProps {
  environment: string
  apiStatus: {
    text: string
    color: StatusColor
  }
  visible: boolean
  className?: string
}

export const Controller = memo(function DebugInfoTooltipController(props: ControllerProps) {
  const showDebug = useStore((state) => state.showDebug)
  const setShowDebug = useStore((state) => state.setShowDebug)
  const navigate = useNavigate()

  return (
    <View
      {...props}
      showDebug={showDebug}
      onShowDebugChange={setShowDebug}
      onChangelogNavigate={() => void navigate({ to: '/settings/changelog' })}
    />
  )
})

Controller.displayName = 'DebugInfoTooltip_Controller'
